import React from 'react';

import { PERMISSIONS } from './auth/permissions.js';

import LoadHome from 'bundle-loader?lazy&name=versions!./components/routes/home/index.js';
import LoadVersions from 'bundle-loader?lazy&name=versions!./components/routes/versions/index.js';
import LoadVersion from 'bundle-loader?lazy&name=version!./components/routes/version/index.js';
import LoadAccessDenied from 'bundle-loader?lazy&name=version!./components/routes/access-denied/access-denied.jsx';

const Version = React.lazy( () => import( './components/routes/version/index.js' ) );

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

const params = {
    uuid: ( paramName ) => `${ paramName ? ( ':' + paramName ) : '' }([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})`,
};

export const COMPANY_ID = params.uuid( 'companyId' );
export const VERSION_ID = params.uuid( 'versionId' );

export const routes = [
    {
        title: 'Home',
        pattern: '/',
        load: LoadHome,
        requireAuthentication: true,
        permissions: PERMISSIONS
    },
    {
        title: 'privacy.pageTitle.version',
        pattern: `/${ COMPANY_ID }?`,
        load: LoadVersions,
        requireAuthentication: true,
        permission: PERMISSIONS.LIST_VERSIONS,
        permissions: PERMISSIONS
    },
    {
        title: 'Create Privacy Version',
        pattern: `/${ COMPANY_ID }?/versions/create`,
        load: LoadVersion,
        requireAuthentication: true,
        permission: PERMISSIONS.EDIT_VERSIONS,
        permissions: PERMISSIONS,
        render: ( props ) => (
            <Version { ...props } type="edit" />
        )
    },
    {
        title: 'Edit Privacy Version',
        pattern: `/${ COMPANY_ID }?/versions/edit/${ VERSION_ID }?`,
        load: LoadVersion,
        requireAuthentication: true,
        permission: PERMISSIONS.EDIT_VERSIONS,
        permissions: PERMISSIONS,
        render: ( props ) => (
            <Version { ...props } type="edit" />
        )
    },
    {
        title: 'View Privacy Version',
        pattern: `/${ COMPANY_ID }?/versions/view/${ VERSION_ID }?`,
        load: LoadVersion,
        requireAuthentication: true,
        permission: PERMISSIONS.READ_VERSIONS,
        permissions: PERMISSIONS,
        render: ( props ) => (
            <Version { ...props } type="view" />
        )
    },
    {
        title: 'Access Denied',
        pattern: `/${ COMPANY_ID }?/access-denied`,
        requireAuthentication: true,
        load: LoadAccessDenied
    },
];

export const routeList = Object.values( routes ).sort( ( a, b ) => ( a?.id || 0 ) - ( b?.id || 0 ) );

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}
